import React from "react";

import "./styles.less";

export const BtnGroup = ({ children }) => {
  return <div className="mobile-btn-group">{children}</div>;
};
